import React from 'react';
import DEFINE, { PATHS } from './../constants/Define';
import OrderMenu from './orderMenu';
import VoucherMenu from './voucherMenu';
import TourMenu from './tourMenu';
import HotelMenu from './hotelMenu';
import FlightMenu from './flightMenu';
import WebsiteMenu from './websiteMenu';
import UserMenu from './userMenu';
import ReportMenu from './reportMenu';
import SystemMenu from './systemMenu';
import VinWonderMenu from './winWonderMenu';
import promotionMenu from './promotionMenu';
import CreditPointMenu from './creditPointMenu';
import VinpearlGolfMenu from './vinpearlGolfMenu';
import fnbMenu from './fnbMenu';
import AppMenu from './appMenu'
export default [
    {
        title: "dashboard",
        group: "dashboard",
        path: '/',
        exact: true,
        icon: 'dashboard',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.HOME,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW]
    },
    ...OrderMenu,
    ...VoucherMenu,
    ...VinWonderMenu,
    ...TourMenu,
    ...fnbMenu,
    ...HotelMenu,
    ...promotionMenu,
    ...CreditPointMenu,
    ...VinpearlGolfMenu,
    ...FlightMenu,
    ...WebsiteMenu,
    ...AppMenu,
    ...UserMenu,
    ...ReportMenu,
    ...SystemMenu,
    {
        title: "403",
        group: "403",
        path: '/403',
        exact: true,
        icon: 'dashboard',
        show: false,
    }, {
        title: "profile",
        group: "profile",
        path: PATHS.PROFILE.path,
        exact: true,
        icon: 'dashboard',
        show: false,
    }
];
